module.exports = __webpack_public_path__ + "assets/images/SucsessPaymantShape.951e28f2409325fa2947da7bc63d5727.png";